import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { environment } from '../components/Services/environment';

const endpoint = environment.serverUrl;

// Map routes to their required scope types
const ROUTE_SCOPE_MAP = {
  '/customers': 'customer',
  '/collections': 'collection',
  '/pages': 'page',
  '/metaobjects': 'metaobject',
  '/definitions': 'metaobject',
  // '/orders': 'order',
  '/translations': 'translation',
  '/menu': 'menu'
};

/**
 * Optimized hook - only checks scopes for the current route
 */
export const useRouteScopes = (storeUrl) => {
  const location = useLocation();
  const [scopeData, setScopeData] = useState({
    needsUpdate: false,
    chargeAlert: false,
    chargeUrl: '',
    loading: true
  });

  useEffect(() => {
    if (!storeUrl) return;

    const scopeType = ROUTE_SCOPE_MAP[location.pathname];
    if (!scopeType) {
      setScopeData({ needsUpdate: false, chargeAlert: false, chargeUrl: '', loading: false });
      return;
    }

    checkRouteScope(scopeType);
  }, [storeUrl, location.pathname]);

  const checkRouteScope = async (type) => {
    setScopeData(prev => ({ ...prev, loading: true }));

    try {
      const response = await fetch(
        `${endpoint}/api/Store/scope-check?storeUrl=${storeUrl}&type=${type}`
      );
      const data = await response.json();

      if (data.status === true && data.type === "scope") {
        setScopeData({ needsUpdate: true, chargeAlert: false, chargeUrl: '', loading: false });
      } else if (data.status === false && data.type === "charge") {
        await checkFeatureLimitReached(type);
      } else {
        setScopeData({ needsUpdate: false, chargeAlert: false, chargeUrl: '', loading: false });
      }
    } catch (error) {
      console.error(`Error checking ${type} scope:`, error);
      setScopeData({ needsUpdate: false, chargeAlert: false, chargeUrl: '', loading: false });
    }
  };

  const checkFeatureLimitReached = async (type) => {
    try {
      const apiPath = type.charAt(0).toUpperCase() + type.slice(1);
      const response = await fetch(
        `${endpoint}/api/${apiPath}/limit-reached?storeUrl=${storeUrl}`
      );
      const data = await response.json();

      if (data.status === true) {
        setScopeData({ 
          needsUpdate: false, 
          chargeAlert: true, 
          chargeUrl: data.chargeUrl,
          loading: false 
        });
      } else {
        setScopeData({ needsUpdate: false, chargeAlert: false, chargeUrl: '', loading: false });
      }
    } catch (error) {
      console.error(`Error checking ${type} limit:`, error);
      setScopeData({ needsUpdate: false, chargeAlert: false, chargeUrl: '', loading: false });
    }
  };

  return scopeData;
};
